import { carrierUtils } from "@flights/web-api-utils-universal";
import { NON_INCLUDED_FEATURES_AIRLINES, SELLABLE_FEATURES_AIRLINES } from "./constants.js";
export const areSellableFeaturesRequiredByAirline = (segments) => carrierUtils.hasCarrier(segments, SELLABLE_FEATURES_AIRLINES);
export const areExcludedFeaturesRequiredByAirline = (segments) => carrierUtils.hasCarrier(segments, NON_INCLUDED_FEATURES_AIRLINES);
